import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { Indexes, MediaQuery, Shadow } from '../../../shared/constants/Styles';

export const ModalOverlay = styled.div`
  z-index: ${Indexes.MODAL};
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(33, 37, 41, 0.45);
`;

export const ModalWrapper = styled.div`
  background-color: ${Color.WHITE};
  border-radius: 15px;
  text-align: center;
  box-shadow: ${Shadow.BLUE_ACTIVE};

  ${MediaQuery.S_AND_DOWN} {
    width: 100%;
    display: flex;
    position: relative;
    border-radius: 0px;
    height: 100%;
  }
`;

export const StyledCross = styled.button`
  float: right;
  margin: 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  height: 35px;
  width: 35px;

  svg {
    font-size: 20px;
    padding-top: 5px;
  }

  &:hover {
    background-color: ${Color.WHISPER};
  }

  ${MediaQuery.S_AND_DOWN} {
    position: absolute;
    right: 0px;
  }
`;

export const ModalContent = styled.div`
  background-color: transparent;
  margin: 55px 32px 32px 32px;

  ${MediaQuery.S_AND_DOWN} {
    justify-content: center;
    display: flex;
    margin: auto;
    padding: 0px 15px;
  }
`;
